import { render } from "./ClipShowModalComponent.vue?vue&type=template&id=1f96f2f8&scoped=true"
import script from "./ClipShowModalComponent.vue?vue&type=script&lang=js"
export * from "./ClipShowModalComponent.vue?vue&type=script&lang=js"

import "./ClipShowModalComponent.vue?vue&type=style&index=0&id=1f96f2f8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f96f2f8"]])

export default __exports__